module.exports = __webpack_public_path__ + "static/media/droneActive.96688850.svg";